export default __webpack_public_path__ + "static/media/UCityProWeb-Regular.6686a9a8.woff2";